module.exports = __webpack_public_path__ + "static/media/musical-note.545bb4be.svg";